export const DATA = [
  {
    list: [
      {
        label: 'not-found.everyday-sneakers',
        url: '/collections/womens-runners',
        imageUrl:
          'https://images.ctfassets.net/9uo1qvvet3xa/1z4Rx0CJeXXMdUzdxqtbju/85c462222fc0815293f12d9f0956a165/Womens_Explore_More_Everyday.jpg',
      },
      {
        label: 'not-found.active-shoes',
        url: '/collections/womens-running-shoes',
        imageUrl:
          'https://images.ctfassets.net/9uo1qvvet3xa/6vgtXNbDYOD9AMweSxZSKG/b0242f0a1a3bf816c460540798b7c94e/Womens_Explore_More_Active.jpg',
      },
      {
        label: 'not-found.slip-ons',
        url: '/collections/womens-loungers',
        imageUrl:
          'https://images.ctfassets.net/9uo1qvvet3xa/29wySlOONG7b5jAAk0zOjW/0b68aea8513e6186df266133d33898f2/Womens_Explore_More_SlipOn.jpg',
      },
    ],
  },
  {
    list: [
      {
        label: 'not-found.everyday-sneakers',
        url: '/collections/mens-runners',
        imageUrl:
          'https://images.ctfassets.net/9uo1qvvet3xa/5rXwngixoDtKvZwQNm2nh8/79a6cd300c1596fcede0101199517f1a/Mens_Explore_More_Everyday.jpg',
      },
      {
        label: 'not-found.active-shoes',
        url: '/collections/mens-running-shoes',
        imageUrl:
          'https://images.ctfassets.net/9uo1qvvet3xa/2wl9KVVJX5EO2KfmfdABhv/49ccdf8a83a773c90e53937a27a4583b/Mens_Explore_More_Active.jpg',
      },
      {
        label: 'not-found.slip-ons',
        url: '/collections/mens-loungers',
        imageUrl:
          'https://images.ctfassets.net/9uo1qvvet3xa/21HuDhgo3luwaDVQrJ3zKS/14d37db76ce1df6ab6d7c7d9f8cf0c1f/Mens_Explore_More_SlipOn.jpg',
      },
    ],
  },
];

export const TAB_LABELS = ['not-found.womens', 'not-found.mens'];
